// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const espurr: PokeData = {
  "id": 677,
  "name": "espurr",
  "height": 3,
  "weight": 35,
  "base_experience": 71,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "scratch",
    "leer",
    "psybeam",
    "confusion",
    "light-screen",
    "reflect",
    "fake-out",
    "covet",
    "psyshock",
    "disarming-voice"
  ],
  "moves": [
    "scratch",
    "leer",
    "reflect",
    "psychic",
    "psywave",
    "future-sight",
    "synchronize",
    "psychic-fangs",
    "prismatic-cage",
    "healing-wish",
    "calm-mind",
    "psy-ball",
    "kinesis"
  ],
  "evolution_chain": {
    "id": 348,
    "item": null,
    "species": [
      {
        "name": "espurr",
        "order": 678,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "meowstic",
        "order": 679,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 677,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 59.5,
    "speed": 68,
    "ability_power": 63
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
